import { id, allocation, Identifiable, Allocation } from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { reduceResource } from "../resource";

const initialState = { ...allocation, uuid: id };

function handleEditRequest(
  allocation: Identifiable<Allocation>,
  req: Boundaries["editAllocation"]["request"],
) {
  return allocation.uuid === req.allocation.uuid
    ? { ...allocation, ...req.nextAllocation }
    : allocation;
}

function handleEditSuccess(
  allocation: Identifiable<Allocation>,
  nextAlloc: Boundaries["editAllocation"]["success"],
) {
  return allocation.uuid === nextAlloc.uuid
    ? { ...allocation, ...nextAlloc }
    : allocation;
}

function handleEditFailure(
  allocation: Identifiable<Allocation>,
  req: Boundaries["editAllocation"]["failure"],
) {
  return allocation.uuid === req.allocation.uuid
    ? { ...allocation, ...req.allocation }
    : allocation;
}

function handleRemoveProjectResource(
  allocation: Identifiable<Allocation>,
  {
    projectResource,
    hasRequestedAllocationTransfer,
    destinationResource,
  }: Boundaries["removeResourceFromProject"]["success"],
) {
  return hasRequestedAllocationTransfer &&
    allocation.resource.uuid === projectResource.resource.uuid
    ? { ...allocation, resource: destinationResource.resource }
    : allocation;
}

function handleRemoveResource(
  allocation: Identifiable<Allocation>,
  {
    resource,
    hasRequestedAllocationTransfer,
    destinationResource,
  }: Boundaries["removeResourceFromPlanzone"]["success"],
) {
  return hasRequestedAllocationTransfer &&
    allocation.resource.uuid === resource.uuid
    ? { ...allocation, resource: destinationResource }
    : allocation;
}

function propagateEvent(
  allocation = initialState,
  event: Event,
): Identifiable<Allocation> {
  return {
    ...allocation,
    resource: reduceResource(allocation.resource, event),
  };
}

const reduceAllocation = createStateReducer(
  initialState,
  {
    [events.editAllocationRequested]: handleEditRequest,
    [events.editAllocationSucceeded]: handleEditSuccess,
    [events.editAllocationFailed]: handleEditFailure,
    [events.removeResourceFromProjectSucceeded]: handleRemoveProjectResource,
    [events.removeResourceFromPlanzoneSucceeded]: handleRemoveResource,
  },
  propagateEvent,
);

export { reduceAllocation };
